module.exports = __webpack_public_path__ + "img/edit-gray.9ca49f12.svg";